import { Space } from "antd";
import { FC, useEffect, useState } from "react";
import Box from "../../../components/Box";
import Container from "../../../components/Container";
import Button from "../../../components/UI/Button";
import SelectInput from "../../../components/UI/SelectInput";
import SmartSearch from "../../../components/UI/SmartSearch";
import { SearchOptionEnum } from "../../../enums/searchOptionEnum";
import useMonthYear from "../../../hooks/useMonthYear";
import useSmartSearchParams from "../../../hooks/useSmartSearchParams";
import { notificationError } from "../../../services/notification";
import { MonthlyReportsGameTypeFilter, getMonthlyReports, getMonthlyReportsGameTypeFilter } from "../../../services/reports";
import { Output } from "../../../services/types";
import { ISelectOption } from "../../../components/UI/SelectInput/types";
import dayjs from "dayjs";

const MonthlyReports: FC = () => {
  const [search, setSearch] = useState<string>("");
  const [gameType, setGameType] = useState<string | null>();
  const [gameTypeOptions, setGameTypeOptions] = useState<ISelectOption[]>([])
  const [validSearch, setValidSearch] = useState<boolean>(false);
  const [params, setParams] = useSmartSearchParams();
  const [isMonted, setIsMonted] = useState(false)
  const { month, year, years, isMonthEmpty, isYearEmpty, setMonth, setYear } =
    useMonthYear();

 const monthOptions = dayjs
  .months()
  .map((month, index) => ({ name: month, value: index + 1 }))

  const actualMonth = monthOptions.find((month) => month.name === dayjs().format('MMMM'))

  const initialize = async () => {
    try {
      const serverOptions = await getMonthlyReportsGameTypeFilter()
      const options: ISelectOption[] = []
      serverOptions.forEach((option) => {
        const name = Object.keys(option)[0];
        const value = option[name];
        options.push({
          name,
          value
        });
      });
      setGameType(options[0].value)
      setGameTypeOptions(options)
      var today = dayjs();
      setMonth(today.get("month"))  //month is zero based so it works out to last month as it should.
    } catch (e) {
      notificationError(`${e}`)
    }     
  }
  
  useEffect(() => {
    if(actualMonth) setMonth(actualMonth.value)
    initialize()
  },[])
  
  const disabled =
    !validSearch ||
    !search.length ||
    !gameType?.length ||
    isMonthEmpty ||
    isYearEmpty;

  const refreshReport = async (output: Output) => {
    try {
      const response = await getMonthlyReports({
        output,
        gametype: gameType!,
        locationId: params.id!,
        month: month!,
        year: year!,
      });


    } catch (e) {
      if (e instanceof Error) {
        notificationError(e.message);
        return;
      }

      notificationError("Cannot get monthly reports", (e as any).message);
    }
  };

  return (
    <Container>
      <Box backgroundColor="white" padding="1.1em 1.8em">
        <Space direction="horizontal" size="middle" wrap align="center">
          <SmartSearch
            autoFocus 
            label="Smart Search"
            status="active,closed"
            searchBy={[SearchOptionEnum.LOCATION]}
            onChange={(e: string) => setSearch(e)}
            value={search}
            onValidSearch={setValidSearch}
            onObjValueChange={(e: any) => setParams({ ...params, ...e })}
          />

          <SelectInput
            label="Month"
            options={monthOptions}
            onSelectChange={(e) => setMonth(e)}
            value={month}
          />

          <SelectInput
            label="Year"
            options={years}
            onSelectChange={(e) => setYear(e)}
            value={year}
          />

          {gameTypeOptions.length > 1 && (
            <SelectInput
              label="Game Type"
              options={gameTypeOptions}
              onSelectChange={(e) => setGameType(e)}
              value={gameType}
            />
          )}
          {gameType!=="ebingo" &&
            <Button
              type="primary"
              disabled={disabled}
              onClick={() => refreshReport(Output.CSV)}
            >
              Save as CSV
            </Button>
          }
          <Button
            type="primary"
            disabled={disabled}
            onClick={() => refreshReport(Output.PDF)}
          >
            Save as PDF
          </Button>
          <Button
            type="primary"
            disabled={disabled}
            onClick={() => refreshReport(Output.XLS)}
          >
            Save as XLS
          </Button>
        </Space>
      </Box>
    </Container>
  );
};

export default MonthlyReports;
